var exports = {
  "button": "Button.module__button___YjlyYj",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___YjlyYj",
  "small": "Button.module__small___YjlyYj",
  "compact": "Button.module__compact___YjlyYj",
  "superCompact": "Button.module__superCompact___YjlyYj",
  "fitContent": "Button.module__fitContent___YjlyYj",
  "fitContainer": "Button.module__fitContainer___YjlyYj",
  "square": "Button.module__square___YjlyYj",
  "primary": "Button.module__primary___YjlyYj",
  "secondary": "Button.module__secondary___YjlyYj",
  "danger": "Button.module__danger___YjlyYj",
  "inverted": "Button.module__inverted___YjlyYj",
  "invertedOutline": "Button.module__invertedOutline___YjlyYj",
  "ghost": "Button.module__ghost___YjlyYj",
  "recording": "Button.module__recording___YjlyYj",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___YjlyYj",
  "spinner": "Button.module__spinner___YjlyYj",
  "spinnerInner": "Button.module__spinnerInner___YjlyYj",
  "spinnerItem": "Button.module__spinnerItem___YjlyYj",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___YjlyYj",
  "iconWrapper": "Button.module__iconWrapper___YjlyYj",
  "spinnerWrapper": "Button.module__spinnerWrapper___YjlyYj",
  "hidden": "Button.module__hidden___YjlyYj",
  "grid": "Button.module__grid___YjlyYj",
};

__webpack_require__.r(module.exports = exports);
